import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTable, { createTheme } from 'react-data-table-component';
import dateFormat from "dateformat";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AdminLayout from '../layout/AdminLayout';
import { apiError } from '../../helpers/ErrorHelper';
import { get, put, post, setAuthToken, del } from '../../config/ApiConfig';
import { tableCustomLoader } from '../../helpers/StyleHelper';
import { useAuth } from '../../context/AuthContext';
import { getCountries, getCurrencies, getStates } from '../../models/MasterModel';
import { useTheme } from '../../context/ThemeContext';
import { createClient, editClient, getClients, removeClient, saveClientsToStorage } from '../../models/ClientModel';
import AddClientModal from '../modals/Clients/AddClientModal';
import UpdateClientModal from '../modals/Clients/UpdateClientModal';
import DeleteClientModal from '../modals/Clients/DeleteClientModal';
import ClientTables from '../tables/ClientTables';
import { useNotificationCount } from '../../context/NotificationCountContext';
import { checkPermission } from '../../helpers/GeneralHelper';
import Error403 from './Error403';


function Clients() {

    const { notificationCount, setNotificationCount } = useNotificationCount();

    const { theme, toggleTheme } = useTheme();

    const { state } = useAuth(); 

    let user_data = state.user_data;
  
    const navigate = useNavigate();  
  
    const loader = document.getElementById('loading');

    const [modalKey, setModalKey] = useState(0);
    
    //Add Client Start
    const [showAddClientModal, setShowAddClientModal] = useState(false);
    //Add Client End



    //Update Client Start
    const [showUpdateClientModal, setShowUpdateClientModal] = useState(false);

    const [clientData, setClientData] = useState({});

    const openUpdateClientModal = (client_data) =>{
        setClientData(client_data);
        setModalKey(prevKey => prevKey + 1); 
        setShowUpdateClientModal(true);
    }  
    //Update Client End


    //Update Client Old Start
    const [_client_id, setClientID] = useState('');   
    //Update Client Old End


    //Delete Client Start
    const [showDeleteClientModal, setShowDeleteClientModal] = useState(false);

    const openDeleteClientModal = (client_data) =>{
        setClientData(client_data);
        setModalKey(prevKey => prevKey + 1); 
        setShowDeleteClientModal(true);
    }  
    //Delete Client End


    //Flush Client Start
    const flushClient = async() => {
        localStorage.removeItem("clients");
        fetchClients(limit, page); 
    }  
    //Flush Client End

    
    //Client List Start
    const [data, setData] = useState([]);
    const [cacheTime, setCacheTime] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);


    const fetchClients = async(newLimit, page) => {
        setLoading(true);
    
        try {
            let apiParam = {page: page, limit: newLimit, user_token: user_data.user_token};

            const response = await getClients(apiParam);

            if (typeof response != typeof undefined) {
                setData(response.clients);
                setTotalRows(response.pagination.total_rows);
                setLimit(newLimit);
                setPage(page);
        
                if (response.time) {
                    setCacheTime(response.time);
                }

                setNotificationCount(localStorage.getItem('unread_notification_count'));
            }
            else{
                navigate('/re-login');
            }    
             
            
            setLoading(false);
    
        } catch (error) {
            //console.error(error);
        }
    
        
    };
    //Client List End
    
  return (
    <>
        {checkPermission('menu_clients')===true ? (
        <AdminLayout>
        
            <Helmet>
                <title>Clients - Worktracker Anciletech</title>
            </Helmet>

            <div className="main-content app-content">

                <div className="container-fluid">

                    {/* <!-- Page Header --> */}
                    <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                        <h1 className="page-title fw-semibold fs-18 mb-0">Clients</h1>
                        <div className="ms-md-1 ms-0">
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><a href="javascript:void(0);">Dashboard</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Clients</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/* <!-- Page Header Close --> */}

                    {/* <!-- Start::row-1 --> */}
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card custom-card">
                                <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                                    <div className="card-title">
                                        Last Synced On {cacheTime}
                                    </div>

                                    <div className="d-flex flex-wrap gap-2">
                                        <button className={`btn btn-primary btn-sm ${checkPermission('clients_add')===false ? 'd-none' : ''}`} onClick={() => setShowAddClientModal(true)}>
                                            <i className="ri-add-line me-1 fw-semibold align-middle"></i>Add Client
                                        </button>
                                        

                                        <button className="btn btn-success-light btn-sm" onClick={() => flushClient()}>
                                            <i className="ri-refresh-line me-1 fw-semibold align-middle"></i>Refresh
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <ClientTables
                                          data={data}
                                          setData={setData}
                                          loading={loading}
                                          setLoading={setLoading}
                                          totalRows={totalRows}
                                          setTotalRows={setTotalRows}
                                          page={page}
                                          setPage={setPage}
                                          limit={limit}
                                          setLimit={setLimit}
                                          fetchClients={fetchClients}
                                          openUpdateClientModal={openUpdateClientModal} 
                                          openDeleteClientModal={openDeleteClientModal} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--End::row-1 --> */}


                    {/* <!--Add Client Modal Start--> */}
                    <AddClientModal 
                        showModal={showAddClientModal}
                        setShowModal={setShowAddClientModal}
                        fetchClients={fetchClients}
                        limit={limit}
                        page={page}
                    />
                    {/* <!--Add Client Modal End--> */}


                    {/* <!--Update Client Modal Start--> */}
                    <UpdateClientModal
                        showModal={showUpdateClientModal}
                        setShowModal={setShowUpdateClientModal}
                        clientData={clientData}
                        modalKey={modalKey}
                        fetchClients={fetchClients}
                        limit={limit}
                        page={page} />
                    {/* <!--Update Client Modal End--> */}


                    {/* <!--Delete Client Modal Start--> */}
                    <DeleteClientModal
                        showModal={showDeleteClientModal}
                        setShowModal={setShowDeleteClientModal}
                        clientData={clientData}
                        modalKey={modalKey}
                        fetchClients={fetchClients}
                        limit={limit}
                        page={page}  />
                    {/* <!--Delete Client Modal End--> */}

                </div>

            </div>  

            <Helmet>
                
            </Helmet>
        
        </AdminLayout>
        ) : ( <Error403/>)}
    </>
  )
}

export default Clients
